export default __webpack_public_path__ + "static/download-play-store-min-ceb8a263af65516daac2b36fd7a37773.svg";